import script from "./StrongI18n.vue?vue&type=script&setup=true&lang=js"
export * from "./StrongI18n.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__